// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2XoEA","tab":"ProcedureTabs_tab__2tab8"};